var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2L8 2",
    stroke: "#0071B6",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7L15 7",
    stroke: "#0071B6",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12L7 12",
    stroke: "#0071B6",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12L15 12",
    stroke: "#0071B6",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7L6 7",
    stroke: "#0071B6",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2L15 2",
    stroke: "#0071B6",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 7,
    r: 2,
    fill: "#0071B6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 7,
    r: 2,
    fill: "#0071B6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 7,
    r: 2,
    fill: "#0071B6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 2,
    r: 2,
    fill: "#0071B6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 2,
    r: 2,
    fill: "#0071B6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 2,
    r: 2,
    fill: "#0071B6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 2,
    fill: "#0071B6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 2,
    fill: "#0071B6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 2,
    fill: "#0071B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterViewIcon);
export default __webpack_public_path__ + "static/media/FilterViewIcon.83dca8a2e75d8e712ec9905b8f769a74.svg";
export { ForwardRef as ReactComponent };